// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let JsxRuntime = require("react/jsx-runtime");

function Form__HelpLabel(props) {
  return JsxRuntime.jsx("small", {
    children: props.children,
    className: "text-sm leading-4 text-zinc-600 mb-2 inline-block"
  });
}

let make = Form__HelpLabel;

exports.make = make;
/* react/jsx-runtime Not a pure module */
